<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mt-3 mb-1 text-center">
                <div :class="{active: $route.name === 'book-report'}" class="report-category mb-2" v-if="!isProducer && (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('book-report')">
                    <h5 class="text-white">دفتر</h5>
                </div>
                <div :class="{active: $route.name === 'buy-report'}" class="report-category mb-2"  v-if="companyPostName !== 'فروشنده'"
                     @click="onReportCategoryClicked('buy-report')">
                    <h5 class="text-white">خرید</h5>
                </div>
                <div :class="{active: $route.name === 'sell-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر'|| companyPostName === 'فروشنده')"
                     @click="onReportCategoryClicked('sell-report')">
                    <h5 class="text-white">فروش</h5>
                </div>
                <!--<div :class="{active: $route.name === 'product-report'}" class="report-category mb-2" v-if="!isProducer"-->
                     <!--@click="onReportCategoryClicked('product-report')">-->
                    <!--<h5 class="text-white">تولید</h5>-->
                <!--</div>-->
                <div :class="{active: $route.name === 'inventory'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('inventory')">
                    <h5 class="text-white">موجودی</h5>
                </div>
                <div :class="{active: $route.name === 'inventoryLessProduct'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('inventoryLessProduct')">
                    <h5 class="text-white">کسری موجودی</h5>
                </div>
                <div :class="{active: $route.name === 'receive-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('receive-report')">
                    <h5 class="text-white">دریافت</h5>
                </div>
                <div :class="{active: $route.name === 'payment-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('payment-report')">
                    <h5 class="text-white">پرداخت</h5>
                </div>
                <div :class="{active: $route.name === 'report-provider'}" class="report-category mb-2" v-if="companyPostName !== 'فروشنده'"
                     @click="onReportCategoryClicked('report-provider')">
                    <h5 class="text-white">تامین کننده</h5>
                </div>
                <div :class="{active: $route.name === 'report-customer'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('report-customer')">
                    <h5 class="text-white">مشتری</h5>
                </div>
                <div :class="{active: $route.name === 'receive-check-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('receive-check-report')">
                    <h5 class="text-white">چکهای دریافتی</h5>
                </div>
                <div :class="{active: $route.name === 'payment-check-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('payment-check-report')">
                    <h5 class="text-white">چکهای پرداختی</h5>
                </div>
                 <div :class="{active: $route.name === 'todayCheck'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')"
                     @click="onReportCategoryClicked('todayCheck')">
                    <h5 class="text-white">چکهای سررسید شده</h5>
                </div>
                <div :class="{active: $route.name === 'balance-report'}" class="report-category mb-2" v-if="!isProducer&& (companyPostName === 'صندوق دار' || companyPostName === 'مدیر')&&companyType ==5"
                     @click="onReportCategoryClicked('balance-report')">
                    <h5 class="text-white">تراز آزمایشی</h5>
                </div>

            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'reports',
        components: {},
        data() {
            return {
                isProducer : false,
                producerMobile : "",
                companyPostName:"",
                companyType:"",
            }
        },
        mounted() {
            this.companyType = localStorage.getItem("companyType");

            this.companyPostName = localStorage.getItem("companyPostName");
            if(this.companyPostName === 'تامین کننده'){
                this.isProducer = true;
                this.producerMobile = localStorage.getItem("phoneNumber");
                console.log(this.producerMobile);
            }
        },
        methods: {
            onReportCategoryClicked(name) {
                this.$router.push({name: `${name}`});
            }
        }
    }
</script>